/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import moment from 'moment';
import React, {
    useEffect, useCallback, useState, useContext,
} from 'react';
import Modal from 'react-modal';
import { Link, useParams, useLocation } from 'react-router-dom';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import ThreeDotsLoader from '../../Components/LoadingDots';
import ViewOffersSkeleton from '../../Components/Skeletons/ViewOffersSkeleton';
import LogActivity from '../../Components/LogActivity';
import CommonLog from '../../redux/helper/CommonLog';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
function ViewOffer() {
    const location = useLocation();
    const { id } = useParams();
    const [DealDetails, setDealDetails] = useState([]);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const getDetails = useCallback(
        async () => {
            const OfferDetals = await distributorService.ViewBulkOffer(location.search.split('=')[1]);
            if (!OfferDetals.error && OfferDetals.data.success_status) {
                setTimeout(() => {
                    setDealDetails(OfferDetals.data.data);
                }, 500);
            }
        },
        [id],
    );

    useEffect(() => {
        getDetails();
    }, [getDetails]);

    const handleActivateOrDeactivate = (status) => {
        setactvloader(true);
        distributorService.BulkofferActiveOrDeactivate(status, DealDetails.offer_code).then((res) => {
            if (!res.error && res.data.success_status) {
                setOpenPopup('');
                setactvloader(false);
                SetSuccessMessage(res.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                    setcolorValue(false);
                }, 3000);
                getDetails();
            } else {
                setactvloader(false);
                SetErrorMessage(res.message);
                setcolorValue(true);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }
        });
    };
    return (
        <div>

            <Modal
                style={customStyles}
                isOpen={OpenPopup !== ''}
                ariaHideApp={false}
                onClick={() => {
                    setOpenPopup('');
                    setactvloader(false);
                }}
            >
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                    <div
                        className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                    >
                        <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                            <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                {DealDetails.offer_status === '3' ? 'Activate' : 'Deactivate'}
                                {' '}
                                {' '}
                                Offer
                            </h5>

                            <button
                                type="button"
                                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                            <p className="text-xs6 font-normal text-[#555259]">
                                {`${DealDetails.offer_code}`}
                                {' '}
                                is currently
                                {' '}
                                {DealDetails.offer_status === '1' ? 'Active' : 'Draft'}
                                . Are you sure you
                                {' '}
                                want to
                                {' '}
                                {DealDetails.offer_status === '1' ? 'Deactivate' : 'Activate'}
                                ?
                            </p>
                        </div>

                        <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                            <button
                                onClick={() => {
                                    setOpenPopup('');
                                    setactvloader(false);
                                }}
                                type="button"
                                className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => handleActivateOrDeactivate(DealDetails.offer_status === '3' ? 'activate' : 'deactivate')}
                            >
                                {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {Object.keys(DealDetails).length === 0 ? <ViewOffersSkeleton />
                : (
                    <div className="pt-[25px]">
                        <div className="flex justify-between items-center">
                            <div className="flex items-center">
                                <Link to="/bulk-offers">
                                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                                </Link>
                                <h5 className="text-xs4 font-normal text-[#555259]">View Offer</h5>
                            </div>
                            <div>
                                {(DealDetails.offer_status === '3') && (
                                    <Link to={`/bulk-offers/${location.search.split('=')[1]}/update`}>
                                        <button
                                            type="button"
                                            className="w-[102px] border border-[#555259] rounded-lg h-[38px] text-xs6 font-bold text-[#555259]"
                                        >
                                            Edit Offer
                                        </button>
                                    </Link>
                                )}
                                {(DealDetails.offer_status === '1' || DealDetails.offer_status === '3') && (
                                    <button
                                        onClick={() => setOpenPopup('active')}
                                        type="button"
                                        className="w-[147px] border border-[#555259] rounded-lg h-[38px] text-xs6 font-bold text-[#555259] ml-1"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deactivateOfferModal1"
                                    >
                                        {DealDetails.offer_status === '1' ? 'Deactivate ' : 'Activate '}
                                        Offer
                                    </button>
                                )}
                                <Link to={`/bulk-offers/subscribers/${DealDetails.offer_code}`}>
                                    <button type="button" className="w-[152px] bg-[#555259] rounded-lg h-[38px] text-sm49 font-bold text-[#ffffff]">
                                        View Subscribers
                                    </button>
                                </Link>
                            </div>
                        </div>
                        {Object.keys(DealDetails).length > 0 ? (
                            <div className="px-4 pt-[34px]">
                                <div className="flex -mx-2">
                                    <div className="px-2 w-[14.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Offer Code</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5 break-words">{DealDetails.offer_code}</p>
                                    </div>
                                    <div className="px-2 w-[18.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Offer Tag</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5 break-words">{DealDetails.offer_value}</p>
                                    </div>
                                    <div className="px-2 w-[14.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Start Date</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.start_date}</p>
                                    </div>
                                    <div className="px-2 w-[14.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">End Date</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.end_date}</p>
                                    </div>
                                    <div className="px-2 w-[14.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Type</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.industrial_pocket}</p>
                                    </div>
                                    <div className="px-2 w-[14.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Status</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.offer_status === '0' ? 'Inactive' : DealDetails.offer_status === '1' ? 'Active' : DealDetails.offer_status === '2' ? 'Expired' : 'Draft'}
                                        </p>
                                    </div>
                                </div>
                                {DealDetails.description !== ''
                                && (
                                    <div className="pt-5 w-[90%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Description</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1">{DealDetails.description}</p>
                                    </div>
                                ) }
                                <div>
                                    <h5 className="text-sm font-bold text-[#090406] pt-5">Criteria</h5>
                                    <div className="pt-4 w-full rounded-[22px] bg-[#F5F5FA]">
                                        {DealDetails.product_criterion.map((criteria, criIndex) => (
                                            <div className=" px-2.5 pt-4 pb-8 w-full">
                                                <div>
                                                    <p className="text-sm font-bold text-[#090406] pt-1.5 px-[22px]">
                                                        Criterion
                                                        {' '}
                                                        {criIndex + 1}
                                                        {' '}
                                                        {criteria.and_combination === true ? <span className="text-[#ED1C24]">*</span>
                                                            : <span className="text-[#808285]">(Optional)</span>}
                                                    </p>
                                                    <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-4 pb-4">
                                                        <div className="flex -mx-2 px-[22px]">
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Minimum Value</p>
                                                                {criteria.MIN_VALUE !== ''
                                                                    ? <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">{criteria.MIN_VALUE}</p>
                                                                    : <p className="text-lg font-normal text-[#090406] pt-0.5 break-words pl-8">-</p>}
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Minimum Quantity</p>
                                                                {criteria.MIN_QUANTITY !== ''
                                                                    ? <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">{criteria.MIN_QUANTITY}</p>
                                                                    : <p className="text-lg font-normal text-[#090406] pt-0.5 break-words pl-8">-</p>}
                                                            </div>
                                                        </div>
                                                        <div className="flex -mx-2 pt-6 pb-3 px-[22px]">
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Trade Discount</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">{criteria.TRADE_DISCOUNT} </p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Additional Discount</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">{criteria.ADDITIONAL_DISCOUNT}</p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Fixed Discount</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">{criteria.FIXED_CASHBACK}</p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Fulfillment Discount</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">{criteria.FULFILMENT_CASHBACK}</p>
                                                            </div>
                                                        </div>
                                                        {criteria.product_parameters.map((productParameter, paraIndex) => (
                                                            <div className="rounded-lg bg-[#F5F5FA] px-3.5 py-3 w-[90%] mt-3">
                                                                <div className="px-3.5">
                                                                    <h5 className="text-sm font-bold text-[#090406] pb-3">
                                                                        Product Parameter(
                                                                        {paraIndex + 1}
                                                                        )
                                                                    </h5>
                                                                    <div className="flex -mx-2 w-[90%]">
                                                                        <div className="px-2 w-1/4">
                                                                            <p className="text-xs2 font-semibold text-[#808285]">Main Category</p>
                                                                            <p className="text-lg font-normal text-[#090406] pt-0.5">{productParameter.SEGMENT1}</p>
                                                                        </div>
                                                                        <div className="px-2 w-1/4">
                                                                            <p className="text-xs2 font-semibold text-[#808285]">Product Group</p>
                                                                            <p className="text-lg font-normal text-[#090406] pt-0.5">{productParameter.SEGMENT2}</p>
                                                                        </div>
                                                                        <div className="px-2 w-1/4">
                                                                            <p className="text-xs2 font-semibold text-[#808285]">Product Sub Group</p>
                                                                            <p className="text-lg font-normal text-[#090406] pt-0.5">{productParameter.SEGMENT3}</p>
                                                                        </div>
                                                                        <div className="px-2 w-1/4">
                                                                            <p className="text-xs2 font-semibold text-[#808285]">Product Sub Sub Group</p>
                                                                            <p className="text-lg font-normal text-[#090406] pt-0.5">{productParameter.SEGMENT4}</p>
                                                                        </div>
                                                                    </div>
                                                                    {productParameter.products.map((product, prodIdx) => (
                                                                        <div className="flex -mx-2 pb-2.5">
                                                                            <div className="px-2 mt-[22px]">
                                                                                <p className="text-xs2 font-semibold text-[#808285]">
                                                                                    Product(SKU)
                                                                                    {' '}
                                                                                    {prodIdx + 1}
                                                                                </p>
                                                                                <p className="text-lg font-normal text-[#090406] pt-0.5 break-words">
                                                                                    {product.PRODUCT_NAME}
                                                                                    {' - '}
                                                                                    {product.PRODUCT_DESCRIPTION}
                                                                                    (
                                                                                    {product.CONCATENATED_SEGMENTS}
                                                                                    )
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="mt-[22px] w-[392px]">
                                    <h5 className="text-sm font-bold text-[#090406]">Activity Log</h5>
                                    <div className="mt-2 rounded-[22px] bg-[#F5F5FA] p-[15px] w-full">
                                        <div className="bg-[#ffffff] rounded-[16px] px-[19px] pt-[13px] pb-6">

                                            <>
                                                <LogActivity
                                                    componentName="offer"
                                                    details={DealDetails}
                                                />

                                            </>

                                            <CommonLog
                                                date={moment.unix(DealDetails.created_at).format('YYYY/MM/DD').split('/').reverse()
                                                    .join('/')}
                                                time={moment.unix(DealDetails?.created_at).format('hh:mm a')}
                                                name={DealDetails.created_user_name}
                                                action="created"
                                                componentName="offer"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : 'Loading...!!'}
                    </div>
                )}
        </div>
    );
}

export default ViewOffer;
